module.exports = __webpack_public_path__ + "img/map-5-f.4a9c6970.png";